import { ForwardAccumulatorTraderInfos } from '@/App/tiles/ForwardAccumulator/parts/Footer/ForwardAccumulatorTraderInfos.tsx';
import { PriceButton } from '@/App/tiles/ForwardAccumulator/parts/Footer/PriceButton.tsx';
import { TimestampButton } from '@/App/tiles/ForwardAccumulator/parts/Footer/TimeStampButton.tsx';

const Footer = () => {
  return (
    <div className="mt-auto px-8px pt-16px pb-8px">
      <PriceButton />
      <div className="d-flex flex-between">
        <TimestampButton />
        <ForwardAccumulatorTraderInfos />
      </div>
    </div>
  );
};

export default Footer;
